import { Link, routes } from '@redwoodjs/router'
import { Toaster } from '@redwoodjs/web/toast'

type StrengthExerciseSetLayoutProps = {
  children: React.ReactNode
}

const StrengthExerciseSetsLayout = ({ children }: StrengthExerciseSetLayoutProps) => {
  return (
    <div className="rw-scaffold">
      <Toaster />
      <header className="rw-header">
        <h1 className="rw-heading rw-heading-primary">
          <Link
            to={routes.strengthExerciseSets()}
            className="rw-link"
          >
            StrengthExerciseSets
          </Link>
        </h1>
        <Link
          to={routes.newStrengthExerciseSet()}
          className="rw-button rw-button-green"
        >
          <div className="rw-button-icon">+</div> New StrengthExerciseSet
        </Link>
      </header>
      <main className="rw-main">{children}</main>
    </div>
  )
}

export default StrengthExerciseSetsLayout
